module.exports = __webpack_public_path__ + "media/images/city/005-saint-paul-cathedral-40091b5cf74fd13024793dff0e89383e.svg";